import { IMG } from "@/lib/images";
import type {
  CartItem,
  CategoryFilter,
  CategoryTab,
  Collection,
  Product,
  Profile,
  User,
} from "./types";

export const CATEGORY_TABS: CategoryTab[] = [
  { slug: "outing-wear", label: "Outing Wear" },
  { slug: "home-wear", label: "Home Wear" },
  { slug: "kids", label: "Kids" },
  { slug: "bags", label: "Bags" },
  { slug: "shoes", label: "Shoes" },
];

export const CATEGORY_FILTERS: CategoryFilter[] = CATEGORY_TABS.map((tab) => ({
  label: tab.label,
  slug: tab.slug,
}));

export const SIZE_FILTERS = ["XS", "S", "M", "L", "XL"];

export const COLOR_FILTERS: { name: string; hex: string }[] = [
  { name: "Espresso", hex: "#250f03" },
  { name: "Golden Latte", hex: "#c5a059" },
  { name: "Cream", hex: "#f3f3f4" },
  { name: "Stone", hex: "#c8c6c3" },
  { name: "Noir", hex: "#151613" },
];

export const SORT_OPTIONS = [
  { value: "popularity", label: "SORT BY: POPULARITY" },
  { value: "price-asc", label: "PRICE: LOW TO HIGH" },
  { value: "price-desc", label: "PRICE: HIGH TO LOW" },
  { value: "newest", label: "NEWEST ARRIVALS" },
];

const baseColors = [
  { name: "Chocolate & Gold", hex: "#250f03" },
  { name: "Cream", hex: "#f3f3f4" },
  { name: "Stone", hex: "#c8c6c3" },
];

const care = [
  "Hand wash cold with silk-safe detergent.",
  "Do not bleach or tumble dry.",
  "Cool iron on reverse side if needed.",
];

const material =
  "Crafted from our signature 22-momme Mulberry silk, this piece offers an unparalleled tactile experience. The high density ensures durability while maintaining a liquid-like drape that contours to the body.";

export const PRODUCTS: Product[] = [
  {
    id: "p1",
    slug: "sculpted-silk-midi-dress",
    name: "Sculpted Silk Midi Dress",
    category: "Dresses",
    categorySlug: "outing-wear",
    ref: "SN-2001-CH",
    price: 850,
    images: [IMG.shop1, IMG.pdp2, IMG.pdp3, IMG.pdp4],
    colors: baseColors,
    sizes: ["XS", "S", "M", "L"],
    material,
    care,
    createdAt: "2026-06-01",
    popularity: 97,
  },
  {
    id: "p2",
    slug: "the-heritage-overcoat",
    name: "The Heritage Overcoat",
    category: "Coats",
    categorySlug: "outing-wear",
    ref: "SN-2002-GL",
    price: 1290,
    images: [IMG.shop2, IMG.pdp3, IMG.pdp4, IMG.pdp5],
    colors: baseColors,
    sizes: ["XS", "S", "M", "L"],
    badge: "New Arrival",
    material,
    care,
    createdAt: "2026-07-02",
    popularity: 92,
  },
  {
    id: "p3",
    slug: "organza-cloud-blouse",
    name: "Organza Cloud Blouse",
    category: "Blouses",
    categorySlug: "outing-wear",
    ref: "SN-2003-NC",
    price: 420,
    images: [IMG.shop3, IMG.pdp2, IMG.pdp5, IMG.pdp4],
    colors: baseColors,
    sizes: ["XS", "S", "M", "L"],
    material,
    care,
    createdAt: "2026-05-18",
    popularity: 80,
  },
  {
    id: "p4",
    slug: "midnight-luna-tote",
    name: "Midnight Luna Tote",
    category: "Bags",
    categorySlug: "bags",
    ref: "SN-1102-GL",
    price: 1550,
    images: [IMG.shop4, IMG.cart2, IMG.pdp3, IMG.pdp4],
    colors: baseColors,
    sizes: ["OS"],
    material,
    care,
    createdAt: "2026-06-22",
    popularity: 88,
  },
  {
    id: "p5",
    slug: "wide-leg-linen-trouser",
    name: "Wide-Leg Linen Trouser",
    category: "Trousers",
    categorySlug: "outing-wear",
    ref: "SN-5541-NC",
    price: 380,
    images: [IMG.shop5, IMG.cart3, IMG.pdp2, IMG.pdp4],
    colors: baseColors,
    sizes: ["XS", "S", "M", "L"],
    material,
    care,
    createdAt: "2026-04-11",
    popularity: 74,
  },
  {
    id: "p6",
    slug: "graphic-silk-scarf",
    name: "Graphic Silk Scarf",
    category: "Accessories",
    categorySlug: "outing-wear",
    ref: "SN-3310-GL",
    price: 210,
    images: [IMG.shop6, IMG.pdp5, IMG.pdp3, IMG.pdp2],
    colors: baseColors,
    sizes: ["OS"],
    material,
    care,
    createdAt: "2026-07-10",
    popularity: 68,
  },
  {
    id: "p7",
    slug: "evening-column-gown",
    name: "Evening Column Gown",
    category: "Dresses",
    categorySlug: "outing-wear",
    ref: "SN-2210-NO",
    price: 1800,
    images: [IMG.shop7, IMG.pdp2, IMG.pdp4, IMG.pdp5],
    colors: baseColors,
    sizes: ["XS", "S", "M", "L"],
    material,
    care,
    createdAt: "2026-03-30",
    popularity: 95,
  },
  {
    id: "p8",
    slug: "suede-belgian-loafers",
    name: "Suede Belgian Loafers",
    category: "Shoes",
    categorySlug: "shoes",
    ref: "SN-4408-ST",
    price: 540,
    images: [IMG.shop8, IMG.pdp3, IMG.pdp4, IMG.pdp5],
    colors: baseColors,
    sizes: ["36", "37", "38", "39"],
    material,
    care,
    createdAt: "2026-05-05",
    popularity: 71,
  },
  {
    id: "p9",
    slug: "silk-reverie-lounge-set",
    name: "Silk Reverie Lounge Set",
    category: "Home Wear",
    categorySlug: "home-wear",
    ref: "SN-7701-CH",
    price: 340,
    images: [IMG.pdp5, IMG.pdp1, IMG.pdp2, IMG.pdp3],
    colors: baseColors,
    sizes: ["XS", "S", "M", "L"],
    material,
    care,
    createdAt: "2026-07-18",
    popularity: 90,
  },
  {
    id: "p10",
    slug: "silk-satin-drape-dress",
    name: "Silk Satin Drape Dress",
    category: "Outerwear",
    categorySlug: "outing-wear",
    ref: "SN-2405-CH",
    price: 420,
    images: [IMG.home6, IMG.pdp2, IMG.pdp3, IMG.pdp4],
    colors: baseColors,
    sizes: ["XS", "S", "M", "L"],
    material,
    care,
    createdAt: "2026-07-20",
    popularity: 86,
  },
  {
    id: "p11",
    slug: "woven-espresso-clutch",
    name: "Woven Espresso Clutch",
    category: "Accessories",
    categorySlug: "bags",
    ref: "SN-1150-ES",
    price: 380,
    images: [IMG.home7, IMG.cart2, IMG.pdp4, IMG.pdp5],
    colors: baseColors,
    sizes: ["OS"],
    material,
    care,
    createdAt: "2026-07-21",
    popularity: 79,
  },
  {
    id: "p12",
    slug: "wool-cocoon-coat",
    name: "Wool Cocoon Coat",
    category: "Kids",
    categorySlug: "kids",
    ref: "SN-6602-ST",
    price: 250,
    images: [IMG.home8, IMG.cart1, IMG.pdp3, IMG.pdp4],
    colors: baseColors,
    sizes: ["XS", "S", "M"],
    material,
    care,
    createdAt: "2026-07-22",
    popularity: 66,
  },
  {
    id: "p13",
    slug: "minimalist-t-strap-sandal",
    name: "Minimalist T-Strap Sandal",
    category: "Shoes",
    categorySlug: "shoes",
    ref: "SN-4412-GL",
    price: 290,
    images: [IMG.home9, IMG.pdp4, IMG.pdp5, IMG.pdp2],
    colors: baseColors,
    sizes: ["36", "37", "38", "39"],
    material,
    care,
    createdAt: "2026-07-23",
    popularity: 73,
  },
];

export const NEW_ARRIVAL_SLUGS = [
  "silk-satin-drape-dress",
  "woven-espresso-clutch",
  "wool-cocoon-coat",
  "minimalist-t-strap-sandal",
];

export const COLLECTIONS: Collection[] = [
  {
    id: "c1",
    title: "Outing Wear",
    image: IMG.home2,
    href: "outing-wear",
    cta: "Discover More",
  },
  { id: "c2", title: "The Bag Edit", image: IMG.home3, href: "bags", cta: "Shop Now" },
  { id: "c3", title: "Home & Living", image: IMG.home4, href: "home-wear", cta: "Explore" },
];

export const HERO_IMAGES = { main: IMG.home1, floating: IMG.home2 };
/** Three-image hero loop: each slide is promoted from the small box to the big frame. */
export const HERO_SLIDES = [IMG.home1, IMG.home2, IMG.home3];

export const ETHOS_IMAGE = IMG.home5;
export const AUTH_AMBIENT_IMAGE = IMG.auth1;
export const PROFILE_ATMOSPHERE_IMAGE = IMG.home5;

export const INITIAL_CART_ITEMS: CartItem[] = [
  {
    id: "ci1",
    productId: "p2",
    slug: "the-heritage-overcoat",
    name: "Tailored Wool Blazer",
    ref: "SN-9283-CH",
    image: IMG.cart1,
    color: "Espresso",
    size: "Medium",
    price: 890,
    quantity: 1,
  },
  {
    id: "ci2",
    productId: "p4",
    slug: "midnight-luna-tote",
    name: "Luna Saddle Bag",
    ref: "SN-1102-GL",
    image: IMG.cart2,
    color: "Golden Latte",
    size: "OS",
    price: 1250,
    quantity: 1,
  },
  {
    id: "ci3",
    productId: "p5",
    slug: "wide-leg-linen-trouser",
    name: "Silk-Blend Trousers",
    ref: "SN-5541-NC",
    image: IMG.cart3,
    color: "Cream",
    size: "Small",
    price: 420,
    quantity: 1,
  },
];

export const MOCK_USER: User = {
  id: "u1",
  firstName: "Marwa",
  lastName: "Eldaly",
  email: "marwa@seen.style",
};

export const MOCK_PROFILE: Profile = {
  fullName: "Marwa Eldaly",
  phone: "",
  street: "",
  city: "",
  governorate: "Cairo",
};

export const GOVERNORATES = ["Cairo", "Giza", "Alexandria", "Red Sea"];

export const PROMO_CODES: Record<string, number> = {
  SEEN10: 0.1,
  ELEGANCE: 0.15,
};
